import { bl_aat_claim_account_entitlement_employee_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class ClaimAccountEntitlementEmployeeFileContainerModel extends BaseContainerModel {
    bl_aat_claim_account_entitlement_employee_import_file_hdr: bl_aat_claim_account_entitlement_employee_import_file_hdr_RowClass = new bl_aat_claim_account_entitlement_employee_import_file_hdr_RowClass();
}